export interface ClaimsData {
    DodatnoPolje1: string;
    DodatnoPolje2: string;
    DodatnoPolje3: string;
    DodatnoPolje4: string;
    DodatnoPolje5: string;
    Email: string;
    FullName:string;
    SuperAdministrator: string; //"True" ili "False"
    UserId: string; 
    aud: string;
    exp: number;
    ['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']: string;
    iat:  number;
    iss: string;
    nameid: string;
    nbf: number;
    unique_name: string; // npr."sisAdmin",
    ['Authorization claim']: AuthorizationDataWrapper
}

export interface AuthorizationDataWrapper {
    Autorizacije: AuthorizationData[]
}

export interface AuthorizationData {
    Kompanija: CompanyData[];
    Uloga: UserRoleData;
}

export interface CompanyData {
    DodatnoPolje1: string;
    DodatnoPolje2: string;
    DodatnoPolje3: string;
    DodatnoPolje4: string;
    DodatnoPolje5: string;
    Id: number;
    MB: string;
    Naziv: string;
    PIB: string;
    Sifra: string;
}

export interface UserRoleData {
    DodatnoPolje1: string;
    DodatnoPolje2: string;
    DodatnoPolje3: string;
    DodatnoPolje4: string;
    DodatnoPolje5: string;
    Id: number;
    Naziv: string; 
    Operacije: Operacija[];
}

export interface Operacija {
    Naziv: string
}


export interface CompanyListView {
    Id: number;
    Naziv: string;
    MaticniBrojTA: string;
    UlogaID: number;
    UlogaSifra: string;
    SvojstvoAgencije: string;
    StatusTAUCISu: string;
}